﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import TalcUsage from "./Registration/TalcUsage.svelte";
import Diagnosis from "./Registration/Diagnosis.svelte";
import PersonalMedicalHistory from "./Registration/PersonalMedicalHistory.svelte";
import FamilyMedicalHistory from "./Registration/FamilyMedicalHistory.svelte";
import MedicalProviderHistory from "./Registration/MedicalProviderHistory.svelte";
import DocumentUpload from "./Registration/DocumentUpload.svelte";

const confirmationPages = [
	{
		component: LandingPage,
		routeId: "/Registration",
		confirmationHeading: null
	},
	{
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		confirmationHeading: "Your details"
	},
	{
		component: TalcUsage,
		routeId: "/Registration/TalcumPowderUse",
		confirmationHeading: "Talcum Powder Use"
	},
	{
		component: Diagnosis,
		routeId: "/Registration/Diagnosis",
		confirmationHeading: "Diagnosis of Cancer"
	},
	{
		component: PersonalMedicalHistory,
		routeId: "/Registration/PersonalMedicalHistory",
		confirmationHeading: "Personal Medical History"
	},
	{
		component: FamilyMedicalHistory,
		routeId: "/Registration/FamilyMedicalHistory",
		confirmationHeading: "Family Medical History"
	},
	{
		component: MedicalProviderHistory,
		routeId: "/Registration/MedicalProviders",
		confirmationHeading: "Medical Providers"
	},
	{
		component: DocumentUpload,
		routeId: "/Registration/DocumentUpload",
		confirmationHeading: "Document Upload"
	}
];

export default confirmationPages;
